import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import ownerLevels from 'enums/ownerLevels';
import { makeStyles } from 'styles/util';

import Chip from '@material-ui/core/Chip';

const OwnerLevelChip = ({ ownerLevel }) => {
    const levelClasses = {};
    const { appContext } = useAppContext();
    Object.values(ownerLevels).forEach(o => {
        levelClasses[o.key] = {
            backgroundColor: o.color,
            color: appContext.colors.white
        };
    });
    const useStyles = makeStyles(() => levelClasses);
    const classes = useStyles();

    if(!ownerLevel) {
        return null;
    }
    return (
        <Chip label={ownerLevels[ownerLevel].title} classes={{ root: classes[ownerLevel] }} size="small" />
    );
};

OwnerLevelChip.propTypes = {
    ownerLevel: PropTypes.string
};

export default OwnerLevelChip;
